import * as React from 'react';
import withContainer from '../../containers/WithContainer';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { ContainerNew } from '../../containers/AppContainer';
import './WizardCard.style.scss';
import Appear from '../Appear/Appear';

interface WizardCardProps {
  onNext?: () => void;
  onPrev?: () => void;
  title?: string;
  subTitle?: string;
  isNextHidden?: boolean;
  isPrevHidden?: boolean;
  className?: string;
  nextLabel?: string;
  prevLabel?: string;
  delay?: number;
  duration?: number;
  isLoading?: boolean;
  isDisabled?: boolean;
  match?: any;
  history?: any;
  appContainer?: ContainerNew;
}

class WizardCard extends React.Component<WizardCardProps> {
  getNextStep = () => {
    const step = parseInt(this.props.match.path.split('-')[1]) + 1;
    return step;
  };
  getPrevStep = () => {
    const step = parseInt(this.props.match.path.split('-')[1]) - 1;
    return step;
  };
  onNext = async () => {
    this.props.onNext();
    let nextStep = this.getNextStep();
    const stepName = this.props.appContainer.stepsMapping[nextStep];
    if (this.props.appContainer.stepsMapping[nextStep]) {
      // skip this step if the user hans't selected home studio or
      // if the user hasn't selected mobile
      // or
      // if the current step is makeup brands and no makeup has been selected
      // then skip entry of makeup brands
      if (
        (stepName === 'homeStudioLocation' &&
          !this.props.appContainer.state.provider.offersHome) ||
        (stepName === 'mobileLocation' &&
          !this.props.appContainer.state.provider.offersMobile) /* ||
        (stepName === 'makeup' &&
          !this.props.appContainer.state.step3.can_do_makeup) */
      ) {
        nextStep++;
      } else if (stepName === 'services') {
        nextStep++;
      }


      this.props.history.push('/step-' + nextStep);
    } else {
      window.location.href = 'https://me.flayr.io';
    }
  };
  onPrev = async () => {
    let prevStep = this.getPrevStep();
    const stepName = this.props.appContainer.stepsMapping[prevStep];

    // skip this step if the user hans't selected home studio or
    // if the user hasn't selected mobile
    // or
    // if the current step is makeup brands and no makeup has been selected
    // then skip entry of makeup brands
    if (this.props.appContainer.stepsMapping[prevStep]) {
      if (
        (stepName === 'homeStudioLocation' &&
          !this.props.appContainer.state.provider.offersHome) ||
        (stepName === 'mobileLocation' &&
          !this.props.appContainer.state.provider.offersMobile) ||
        stepName === 'services'
      ) {
        prevStep--;
      }
    }
    await this.props.appContainer.setStep(prevStep);
    this.props.history.push('/step-' + prevStep);
  };

  render() {
    const {
      children,
      className = '',
      isNextHidden,
      isPrevHidden,
      prevLabel = 'Back',
      nextLabel = 'Next',
      onNext,
      onPrev,
      delay = 1,
      duration = 0.5,
      isDisabled,
      isLoading,
      title,
      subTitle,
    } = this.props;
    return (
      <div className={`is-centered ${className} WizardCard__container`}>
        <div className="column is-full-mobile is-two-thirds-tablet is-half-desktop is-one-third-widescreen has-margin-auto">
          <section>
            {(!!title || !!subTitle) && (
              <>
                <div className="title is-4 has-text-primary">{title}</div>
                <div
                  className="subtitle is-5 has-text-dark has-margin-bottom-25"
                  children={subTitle}
                />
              </>
            )}
            {children}
          </section>

          {/* <div className="columns">
              <div className="column is-paddingless">
                <div className="has-padding-top-15 is-centered has-background-white-bis">

                </div>
              </div>
            </div> */}
        </div>

        <footer className="WizardCard__footer has-background-white-bis columns is-marginless is-paddingless">
          <div className="column is-full-mobile is-two-thirds-tablet is-half-desktop is-one-third-widescreen is-paddingless has-margin-auto">
            {!isNextHidden && (
              <div className="flex-row justify-space-between align-items-center has-margin-10">
                <div
                  onClick={this.onPrev}
                  className="flex-row align-items-center"
                >
                  {!isPrevHidden && (
                    <>
                      <svg
                        viewBox="0 0 18 18"
                        role="presentation"
                        aria-hidden="true"
                        focusable="false"
                        style={{
                          height: '1em',
                          width: '1em',
                          fill: 'currentcolor',
                        }}
                      >
                        <path
                          d="m13.7 16.29a1 1 0 1 1 -1.42 1.41l-8-8a1 1 0 0 1 0-1.41l8-8a1 1 0 1 1 1.42 1.41l-7.29 7.29z"
                          fillRule="evenodd"
                        />
                      </svg>
                      &nbsp;
                      {prevLabel}
                    </>
                  )}
                </div>

                <div>
                  <button
                    className={classnames('button is-info', {
                      'is-loading': isLoading,
                    })}
                    onClick={this.onNext}
                    disabled={isDisabled || isLoading}
                  >
                    {!isLoading && (
                      <span>
                        {nextLabel !== 'next' && <> {nextLabel}&nbsp;</>}
                        {nextLabel === 'next' && (
                          <>
                            {' '}
                            {nextLabel}&nbsp;{' '}
                            <i className="fas fa-long-arrow-alt-right" />
                          </>
                        )}
                      </span>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </footer>
      </div>
    );
  }
}

export default withRouter(withContainer(WizardCard));
